export default __webpack_public_path__ + "9a7779dfe96c63ab5de9f53310f97008.jpeg";